angular.module('iqxCore')
.controller('Error404Ctrl', function ($scope) {
	
})
